import { render, staticRenderFns } from "./HomeGoodsListItem.vue?vue&type=template&id=1530640c&scoped=true"
import script from "./HomeGoodsListItem.vue?vue&type=script&lang=js"
export * from "./HomeGoodsListItem.vue?vue&type=script&lang=js"
import style0 from "./HomeGoodsListItem.vue?vue&type=style&index=0&id=1530640c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530640c",
  null
  
)

export default component.exports